module.exports = __webpack_public_path__ + "img/import_button.b7b17031.svg";